import _classCallCheck from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isArray } from 'vega-util';
import * as log from '../log';
import { BaseConcatModel } from './baseconcat';
import { buildModel } from './buildmodel';
import { parseRepeatLayoutSize } from './layoutsize/parse';
export var RepeatModel = /*#__PURE__*/function (_BaseConcatModel) {
  _inherits(RepeatModel, _BaseConcatModel);

  var _super = _createSuper(RepeatModel);

  function RepeatModel(spec, parent, parentGivenName, repeatValues, config) {
    var _this;

    _classCallCheck(this, RepeatModel);

    _this = _super.call(this, spec, 'repeat', parent, parentGivenName, config, repeatValues, spec.resolve);

    if (spec.resolve && spec.resolve.axis && (spec.resolve.axis.x === 'shared' || spec.resolve.axis.y === 'shared')) {
      log.warn(log.message.REPEAT_CANNOT_SHARE_AXIS);
    }

    _this.repeat = spec.repeat;
    _this.children = _this._initChildren(spec, _this.repeat, repeatValues, config);
    return _this;
  }

  _createClass(RepeatModel, [{
    key: "_initChildren",
    value: function _initChildren(spec, repeat, repeater, config) {
      var children = [];
      var row = !isArray(repeat) && repeat.row || [repeater ? repeater.row : null];
      var column = !isArray(repeat) && repeat.column || [repeater ? repeater.column : null];
      var repeatValues = isArray(repeat) && repeat || [repeater ? repeater.repeat : null]; // cross product

      var _iterator = _createForOfIteratorHelper(repeatValues),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var repeatValue = _step.value;

          var _iterator2 = _createForOfIteratorHelper(row),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var rowValue = _step2.value;

              var _iterator3 = _createForOfIteratorHelper(column),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var columnValue = _step3.value;
                  var name = (repeatValue ? "__repeat_repeat_".concat(repeatValue) : '') + (rowValue ? "__repeat_row_".concat(rowValue) : '') + (columnValue ? "__repeat_column_".concat(columnValue) : '');
                  var childRepeat = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue
                  };
                  children.push(buildModel(spec.spec, this, this.getName('child' + name), undefined, childRepeat, config, false));
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return children;
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseRepeatLayoutSize(this);
    }
  }, {
    key: "assembleDefaultLayout",
    value: function assembleDefaultLayout() {
      var repeat = this.repeat;
      var columns = isArray(repeat) ? undefined : repeat.column ? repeat.column.length : 1;
      return Object.assign({}, columns ? {
        columns: columns
      } : {}, {
        bounds: 'full',
        align: 'all'
      });
    }
  }]);

  return RepeatModel;
}(BaseConcatModel);